import * as React from 'react';

export const CameraIcon = () => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M960 336.384a22.464 22.464 0 0 0-22.4-22.4h-222.656L691.968 230.4c0-12.288-12.544-22.4-24.896-22.4H358.976c-12.288 0-22.4 6.016-25.536 22.4l-24.384 83.584H86.4a22.528 22.528 0 0 0-22.4 22.4v576c0 12.288 10.112 22.4 22.4 22.4h851.2c12.288 0 22.4-10.048 22.4-22.4v-252.416h-0.32c0-0.576 0.32-1.088 0.32-1.6a22.4 22.4 0 0 0-44.864 0c0 0.576 0.32 1.088 0.32 1.6H915.2v-58.944a22.4 22.4 0 1 0 44.8 0V558.72h-0.064a22.4 22.4 0 0 0-44.736 0V482.752h0.384c-0.064 0.64-0.384 1.152-0.384 1.792a22.4 22.4 0 1 0 44.8 0c0-0.64-0.32-1.216-0.384-1.792H960V336.384z"
      fill=""
    />
    <path d="M108.8 358.784h806.4v531.2H108.8z" fill="#EDEDED" />
    <path
      d="M108.8 417.344h806.4v44.8H108.8zM108.8 785.984h806.4v44.736H108.8z"
      fill="#9B5F00"
    />
    <path d="M108.8 462.144h806.4v323.84H108.8z" fill="#D87B00" />
    <path
      d="M512 624.384m-205.312 0a205.312 205.312 0 1 0 410.624 0 205.312 205.312 0 1 0-410.624 0Z"
      fill=""
    />
    <path
      d="M512 624.384m-160.512 0a160.512 160.512 0 1 0 321.024 0 160.512 160.512 0 1 0-321.024 0Z"
      fill="#515151"
    />
    <path
      d="M512 624.384m-86.656 0a86.656 86.656 0 1 0 173.312 0 86.656 86.656 0 1 0-173.312 0Z"
      fill=""
    />
    <path
      d="M491.008 601.024m-35.008 0a35.008 35.008 0 1 0 70.016 0 35.008 35.008 0 1 0-70.016 0Z"
      fill="#EDEDED"
    />
    <path
      d="M358.784 313.984l14.784-61.184h278.08l16.128 61.184z"
      fill="#EDEDED"
    />
    <path
      d="M598.656 284.992a9.6 9.6 0 0 1-9.6 9.6H434.944a9.6 9.6 0 1 1 0-19.2h154.048c5.312 0 9.664 4.352 9.664 9.6z"
      fill=""
    />
  </svg>
);
